import {createRoot} from "react-dom/client";
import React, {StrictMode} from "react";
import ForgotPassword from "./ForgotPassword";
import "./..//assets/css/login-new.css";
import { applyAuthNewTheme } from "../lib/applyAuthNewTheme";

applyAuthNewTheme();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ForgotPassword/>
    </StrictMode>
);